import React from 'react'
import { HelmetProvider } from 'react-helmet-async'

import '@asad/ui/dist/index.css'

import '../public/themes/output.css'
import { AppRouter } from './components/router/app-router'
import { usePWA } from './hooks'
import { DrawerProvider } from './context/DrowerContext'
import i18n from './i18n'
import DrawerWrapper from './components/drawer/DrawerWrapper'

const App = () => {
  React.useEffect(() => {
    const savedLanguage = localStorage.getItem('lng') || 'pl'
    i18n.changeLanguage(savedLanguage)
  }, [])

  usePWA()

  return (
    <>
      <meta name='theme-color' />
      <HelmetProvider>
        <DrawerProvider>
          <AppRouter />
          <DrawerWrapper />
        </DrawerProvider>
      </HelmetProvider>
    </>
  )
}

export default App
